document.addEventListener('DOMContentLoaded', () => {
	let page = 1;
	const loadMoreBtn = document.getElementById('load-more-contests-btn');
	const contentContainer = document.querySelector('.contests-index');
	const loadMoreBase = contentContainer && contentContainer.dataset.loadMoreBase;

	if (loadMoreBtn && contentContainer && loadMoreBase){
		loadMoreBtn.addEventListener('click', async () => {
			page++;
			try {
			  const response = await fetch(`${loadMoreBase}?page=${page}`);
			  const data = await response.text();
		      if (!contentContainer.innerHTML.includes(data.trim())) {
		        contentContainer.insertAdjacentHTML('beforeend', data);
		      }
			} catch (error) {
			  console.error('Error fetching more content:', error);
			}
		});
	}

})
